import React from "react";
import type { Feature } from "../../data/landingData";

function SectionHeading({
    eyebrow,
    title,
    subtitle,
}: {
    eyebrow?: string;
    title: string;
    subtitle?: string;
}) {
    return (
        <div className="mx-auto mb-10 max-w-3xl text-center">
            {eyebrow ? (
                <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
                    <span className="h-2 w-2 rounded-full bg-white/60" />
                    {eyebrow}
                </div>
            ) : null}
            <h2 className="text-balance text-2xl font-semibold tracking-tight text-white sm:text-3xl">
                {title}
            </h2>
            {subtitle ? (
                <p className="mt-3 text-pretty text-sm text-white/70 sm:text-base">{subtitle}</p>
            ) : null}
        </div>
    );
}

export default function Features({ items }: { items: Feature[] }) {
    return (
        <section id="funkcje" className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
            <SectionHeading
                eyebrow="Moduły"
                title="Wszystko, czego potrzebujesz"
                subtitle="Włączasz tylko to, co chcesz. Reszta nie przeszkadza."
            />

            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                {items.map((f) => (
                    <a
                        key={f.title}
                        href={f.href ?? "#"}
                        className="group rounded-3xl border border-white/10 bg-white/5 p-5 backdrop-blur hover:bg-white/10 transition"
                    >
                        <div className="flex items-start justify-between gap-4">
                            <div className="flex items-center gap-3">
                                {f.icon}
                                <div>
                                    <div className="text-sm font-semibold text-white">{f.title}</div>
                                    {f.tag ? (
                                        <div className="mt-1 text-xs text-white/50">{f.tag}</div>
                                    ) : null}
                                </div>
                            </div>
                            <span className="text-white/30 group-hover:text-white/60 transition">→</span>
                        </div>
                        <p className="mt-4 text-sm text-white/70">{f.desc}</p>
                    </a>
                ))}
            </div>
        </section>
    );
}
